module.exports = {
  labels: {
    label_color: 'Цвет колонки',
  },
  button: {
    color_edit: 'Изменить',
  },
};
